import { actionCreator, createTypes } from "redux-action-creator";

export const types = createTypes(["SELECT"]);

export const actions = {
  selectMenuOption: actionCreator(types.SELECT, "optionSelected"),
};

export default { types, actions };
